<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";

import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

import BirimSecimi from "../../FormComponet/BirimSecimiAnaBirim.vue";
import StrProsesGiris from "./StrProsesGiris.vue";
import yukleniyor from "../../FormComponet/loader.vue";
import store from "@/state/store"; 


export default {
  mixins: [Api, Sabit],
  page: {
    title: "Proses Veri Girişi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    BirimSecimi,
    StrProsesGiris,
  
    yukleniyor
  },
  data() {
    return {
      title: "Proses Veri Girişi",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Proses Kartları",
          active: true,
        },
        {
          text: "Gösterge Girişi",
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
      loading:1,
      counter: 0,
      UstDonemId: null,
      secilen_birim: "",
      secilen_donem: "",
      universite_id:"",
      universite:0,
      ComboboxDonemler: [],
      Uygulamaid: null,
      Userid:null,
      Kullanici:null,
      Secilen: null,
      sorgula:0,
      Raporgirisid: "",
      DetayId:"",
      DonemId:"",
      Hesaplanmasin:"",
      BirimId:"",
      Filter: {
        DonemId: "",
        BirimId: null,
      },
    };
  },

  methods: {
    /* ANCHOR Combobox yükleme metodları */
   

    Secilmis_Idler(secilmis) {
      if (secilmis != null) {
       
 
          this.secilen_birim = secilmis;

          if(this.secilen_birim==this.universite_id){
            this.universite=1;
          } else{ this.universite=0;}
      }
    },



    /* ANCHOR yükleme butonu kodu */
    yukle() {

        if (this.secilen_birim!=null && this.secilen_birim!="" && 
        this.Filter.DonemId != null && this.Filter.DonemId != "") {

                this.UstDonemId = this.Filter.DonemId;
                this.secilen_donem = this.UstDonemId;
             
                this.loading=0;
                this.sorgula+=1;

            } else {

              this.Message.position = "center";
                      this.Message.icon = "warning";
                      this.Message.title = this.$t('StrGostergeGirisi.Filtreleme.mesaj');
                      this.Message.showConfirmButton = false;
                      this.Message.timer = 1000;

                      Vue.swal(this.Message);



             
            }



     
      

    },

    kaydet(veri){

    let FormData=veri;
    if (veri.Id=="00000000-0000-0000-0000-000000000000" || veri.id==""){
      veri.Deger=0;
      veri.Onay=0;
      FormData.Deger=0;
      let data={"Deger":FormData.Deger,"DonemId":FormData.DonemId,"BirimId":FormData.BirimId,
      "DetayId":FormData.DetayId,"VeriTipi":FormData.VeriTipi,"Aciklama":FormData.Aciklama,"Onay":0,"Deleted":false}

        this.Post("StrPerfRaporGiris", data).then((res) => {
          FormData.Id=res.Data;
          this.$bvModal.hide("Aciklama");

        });

    } else {

       this.Update("StrPerfRaporGiris", FormData);
       this.$bvModal.hide("Aciklama");

    }
    },

    Get() {
  
    },

    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },



  },

  created() {
    this.Get();

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

     let Filter = "&Kisaadi=STR";

    this.ActionsFilterGet({Service: "Ouygulama",  Page:Page,Filter:Filter}).then((res) => {
        if(res){
          this.Uygulamaid=res.Data[0].Id;

        }
    });

     this.Userid = store.getters["auth/TokenUserId"] 



     let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==6 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                  this.ComboboxDonemler.push(res.Data[i]);
                  
                }
              });
         
            });




  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
 
    <Layout>
      <PageHeader :title="title" :items="items" />

     
      <!-- ANCHOR Filtreleme form alanı -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
              
                  <div class="row">
                  <div class="col-md-6">

                  <b-form-group
                    class="mb-2"
                    id="donemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.DonemId"
                      
                      class="form-select"
                      type="text"
                    >
                      <option value=""
                        >{{$t('StrGostergeGirisi.Filtreleme.UstId')}}</option
                      >
                      <option
                        v-for="DonemVerileri in ComboboxDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                        {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>
                  </div>
                  </div>
              
                  <div class="row">
                  <div class="col-md-6">

                      <BirimSecimi
                        :title="''"
                        :title_class="'mb-2'"
                        :closeOnSelect="true"
                        :sutun="'0'"
                        :multiple="false"
                        :YetkiKontrol="1"
                        :BirimTipId="null"
                        @Secilmis_Idler="Secilmis_Idler($event)"
                      />

                  </div>
                  </div>
                 <!--      {{secilen_birim}}  -->
                 
             
                <div class="row">
                  <div class="col-md-6">
                  <b-form-group
                    class="mb-2"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <div class="button-items">
                      <button
                  
                        style="width:99%; margin-bottom:20px"
                        type="button"
                        @click="yukle()"
                        class="btn btn-primary"
                      >
                        Yükle
                      </button>
                    </div>
                  </b-form-group>
                  </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ANCHOR Komponent alanı -->

     
    

      <div class="row">
    
        <div class="col-12">
          <div class="card">
            
            <div class="card-body">          
            

              <div>
              
                <StrProsesGiris
                  :Onayid="index"
                  :BirimId="secilen_birim"
                  :DonemId="secilen_donem"
                  :Sorgulama="sorgula"
                  :Universite="universite"
          
                  @Guncelle="yukle()"
                  @yuklendi="loading=1"
                />

              </div>

            </div>
          </div>
        </div>
      </div>


    
     
  



    </Layout>
    <yukleniyor v-if="loading==0"></yukleniyor>
  </Loader>
 
</template>
